import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'lib-footer',
    imports: [NgTemplateOutlet, CommonModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() footerContent!: TemplateRef<any>;
}